import { jsx } from "@emotion/react/jsx-runtime";
import { Slider as Slider$1 } from "@mui/material";
import { deepmerge } from "../../utils/deepmerge.js";
import { sliderStyles } from "./Slider.styles.js";
import { Tooltip } from "../Tooltip/Tooltip.js";
const ValueLabelComponent = ({
  children,
  value,
  open
}) => {
  return /* @__PURE__ */ jsx(Tooltip, { enterTouchDelay: 0, placement: "top", title: value, open, slotProps: {
    popper: {
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }]
    }
  }, children });
};
const Slider = ({
  slots,
  ...props
}) => {
  const mergedSlots = deepmerge({
    valueLabel: ValueLabelComponent
  }, slots);
  return /* @__PURE__ */ jsx(Slider$1, { css: sliderStyles, slots: mergedSlots, ...props });
};
export {
  Slider
};
//# sourceMappingURL=Slider.js.map
